import { useTheme } from '@emotion/react';
import { Text } from '../Text/index.js';
import { IconBadge } from '../visual-elements/IconBadge/index.js';
import { EMPTY_STATE_DEFAULT_ICONS } from './constants.js';
import { EmptyStateWrapper, EmptyStateTextWrapper } from './styles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const EmptyState = ({
  status = 'informational',
  label,
  description,
  icon,
  cta,
  ...rest
}) => {
  const {
    colorScheme
  } = useTheme();
  return jsxs(EmptyStateWrapper, {
    ...rest,
    children: [jsx(IconBadge, {
      icon: icon !== null && icon !== void 0 ? icon : EMPTY_STATE_DEFAULT_ICONS[status],
      size: "xl",
      backgroundColor: colorScheme.status.default.background[status],
      color: colorScheme.status.default.content[status]
    }), jsxs(EmptyStateTextWrapper, {
      children: [jsx(Text.Body, {
        size: "sm",
        bold: true,
        children: label
      }), description && typeof description === 'string' ? jsx(Text.Body, {
        size: "sm",
        color: colorScheme.content.secondary,
        children: description
      }) : description]
    }), cta]
  });
};
EmptyState.displayName = 'EmptyState';

export { EmptyState };
